import { render } from "./LoggingSessions.vue?vue&type=template&id=12cfc25c&scoped=true"
import script from "./LoggingSessions.vue?vue&type=script&lang=js"
export * from "./LoggingSessions.vue?vue&type=script&lang=js"

import "./LoggingSessions.vue?vue&type=style&index=0&id=12cfc25c&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12cfc25c"]])

export default __exports__